import { Action } from 'redux';

import { SetRootAdminUiState } from '../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../bootstrap/redux/actions/isActionFactory';
import { RootAdminUiState } from './RootAdminUIState';

export interface SetRootAdminUiStateAction extends Action {
  rootAdminUiState: RootAdminUiState;
}

export function setRootAdminUiState(rootAdminUiState: RootAdminUiState): SetRootAdminUiStateAction {
  return {
    type: SetRootAdminUiState,
    rootAdminUiState
  };
}

export const isSetRootAdminUiStateAction = isActionFactory<SetRootAdminUiStateAction>(SetRootAdminUiState);
